import AuditType from '@/ecm/variables/AuditType'
export default class HistoryItem {
    constructor(dto) {
        this.id = 0
        this.user = ''
        this.icon = null
        this.time = ''
        this.description = ''
        this.type = ''

        if (dto) {
            this.id = dto.Id
            this.user = dto.User
            this.time = dto.Time
            this.description = dto.Description
            this.type = dto.Type
            this.icon = this.getIcon(dto.TypeID)
        }
    }

    getIcon(type) {
        var icon = {}
        switch (type) {
            //DOCUMENT
            case AuditType.DOCUMENT_DELETE:
                icon.code = 'mdi-delete'
                icon.color = AuditType.COLOR_DELETE
                break
            case AuditType.DOCUMENT_INSERT:
                icon.code = 'mdi-file'
                icon.color = AuditType.COLOR_INSERT
                break
            case AuditType.DOCUMENT_UPDATE:
                icon.code = 'mdi-pencil'
                icon.color = AuditType.COLOR_UPDATE
                break
            case AuditType.DOCUMENT_UPDATE_ATTACHMENT:
                icon.code = 'mdi-file-edit-outline'
                icon.color = AuditType.COLOR_UPDATE
                break
            case AuditType.DOCUMENT_DELETE_PERMANENTLY:
                icon.code = 'mdi-delete-forever'
                icon.color = AuditType.COLOR_DELETE
                break
            case AuditType.DOCUMENT_RESTORE:
                icon.code = 'mdi-history'
                icon.color = AuditType.COLOR_INSERT
                break
            case AuditType.DOCUMENT_ARCHIVE:
                icon.code = 'mdi-archive'
                icon.color = AuditType.COLOR_ARCHIVE
                break
            case AuditType.DOCUMENT_DOWNLOAD:
            case AuditType.DOCUMENT_DOWNLOAD_EXTERNAL:
                icon.code = 'mdi-download'
                icon.color = AuditType.COLOR_DOWNLOAD
                break
            case AuditType.DOCUMENT_DISPLAY:
            case AuditType.DOCUMENT_DISPLAY_EXTERNAL:
                icon.code = 'mdi-eye'
                icon.color = AuditType.COLOR_DISPLAY
                break
            case AuditType.DOCUMENT_PRINT:
                icon.code = 'mdi-print'
                icon.color = AuditType.COLOR_PRINT
                break
            case AuditType.DOCUMENT_AUTO_UPDATE:
                icon.code = 'mdi-pencil-box-multiple-outline'
                icon.color = AuditType.COLOR_UPDATE
                break
            case AuditType.DOCUMENT_CONTENT_TYPE_CHANGE:
                icon.code = 'mdi-folder-edit-outline'
                icon.color = AuditType.COLOR_UPDATE
                break
            case AuditType.DOCUMENT_SEND_BY_EMAIL:
                icon.code = 'mdi-email'
                icon.color = AuditType.COLOR_PRINT
                break
            case AuditType.DOCUMENT_SIGN:
            case AuditType.DOCUMENT_SIGN_EXTERNAL:
                icon.code = 'mdi-draw'
                icon.color = AuditType.COLOR_UPDATE
                break

            //FLOW
            case AuditType.FLOW_VALIDATE_ACTION:
            case AuditType.DOCUMENT_VALIDATE_EXTERNAL:
                icon.code = 'mdi-check'
                icon.color = AuditType.COLOR_VALIDATE
                break
            case AuditType.FLOW_REFUSE_ACTION:
            case AuditType.DOCUMENT_REJECT_EXTERNAL:
                icon.code = 'mdi-remove'
                icon.color = AuditType.COLOR_REFUSE
                break
            case AuditType.FLOW_DISTRIBUTE_ACTION:
                icon.code = 'mdi-share-variant'
                icon.color = AuditType.COLOR_DISTRIBUTE
                break

            //COMMENT
            case AuditType.COMMENT_CREATE:
            case AuditType.COMMENT_CREATE_EXTERNAL:
                icon.code = 'mdi-comment'
                icon.color = AuditType.COLOR_INSERT
                break
            case AuditType.COMMENT_UPDATE:
                icon.code = 'mdi-comment'
                icon.color = AuditType.COLOR_UPDATE
                break
            case AuditType.COMMENT_DELETE:
                icon.code = 'mdi-comment'
                icon.color = AuditType.COLOR_DELETE
                break


            //DOCUMENT ATTACHMENTS
            case AuditType.DOCUMENT_ATTACHMENT_INSERT:
                icon.code = 'mdi-attachment'
                icon.color = AuditType.COLOR_INSERT
                break
            case AuditType.DOCUMENT_ATTACHMENT_UPDATE:
                icon.code = 'mdi-attachment'
                icon.color = AuditType.COLOR_UPDATE
                break
            case AuditType.DOCUMENT_ATTACHMENT_DELETE:
                icon.code = 'mdi-attachment'
                icon.color = AuditType.COLOR_DELETE
                break
            case AuditType.DOCUMENT_ATTACHMENT_DOWNLOAD:
                icon.code = 'mdi-download'
                icon.color = AuditType.COLOR_DOWNLOAD
                break
            case AuditType.DOCUMENT_ATTACHMENT_DISPLAY:
                icon.code = 'mdi-eye'
                icon.color = AuditType.COLOR_DISPLAY
                break

            default:
                icon.code = 'mdi-help'
                icon.color = AuditType.COLOR_UPDATE
                break
        };
        return icon
    }
}
